import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router";
import { useFirebase } from "react-redux-firebase";
import { Link } from "react-router-dom";

import Button from "../Button";
import Input from "../Input";
import logo from "../../img/equalplay_logo_green.svg";
import { t } from "../../i18n/language";
import LanguageSelector from "../settings/LanguageSelector";
import { APP_VERSION } from "../../version";

import { useSelector } from "react-redux";

export default function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [buttonText, setButtonText] = useState(t("Login"));
  const [errorMessage, setErrorMessage] = useState("");

  const [userUid, setUserUid] = useState("");
  const navigate = useNavigate();
  const location = useLocation();

  const authUid = useSelector((state) => state.firebase.auth?.uid);

  useEffect(() => {
    if (!userUid || authUid !== userUid) return;
    const target = location.state?.from
      ? process.env.PUBLIC_URL + location.state.from
      : process.env.PUBLIC_URL + "/";
    navigate(target);
  }, [authUid, userUid, location.state, navigate]);

  const firebase = useFirebase();

  const onClick = () => {
    return null;
  };

  const onSubmit = (e) => {
    e.preventDefault();
    setButtonText(t("Logging in..."));
    firebase
      .login({ email, password })
      .then((res) => {
        setErrorMessage("");
        if (res?.user?.user?.uid) {
          setUserUid(res.user.user.uid);
          setButtonText(t("Login"));
        }
      })
      .catch((err) => {
        console.log("Login error:", err);
        setButtonText(t("Login"));
        setUserUid("");
        return setErrorMessage(t("Please check your email or password."));
      });
  };

  return (
    <div className="bg-equalplay-dark h-screen relative">
      <div className="absolute px-4 py-3 right-0 text-sm text-white top-0">
        <LanguageSelector />
      </div>
      <div className="absolute px-4 py-3 right-0 bottom-0 text-xs text-white/50 font-mono">
        v{APP_VERSION}
      </div>
      <div className="flex flex-col h-screen items-center justify-center">
        <div className="flex items-center">
          <img className="w-16 h-16" src={logo} alt="Equal Play Logo" />
          <span className="ml-4 text-white text-3xl font-equal-play ">
            Equal Play
          </span>
        </div>
        <form
          onSubmit={onSubmit}
          className="mt-6 px-8 py-10 bg-white w-72 rounded-lg shadow-lg"
        >
          {/* Email input */}
          <div>
            <Input
              label={t("Email")}
              name="email"
              type="email"
              placeholder="me@email.com"
              onChange={(e) => {
                setEmail(e.target.value);
              }}
              value={email}
            />
          </div>
          {/* Password input */}
          <div className="mt-5">
            <Input
              label={t("Password")}
              name="password"
              type="password"
              placeholder="••••••••"
              autoComplete="current-password"
              onChange={(e) => {
                setPassword(e.target.value);
              }}
              value={password}
            />
          </div>
          <div className="mt-6 flex justify-between items-center">
            {/* eslint-disable-next-line */}
            <Link
              to={process.env.PUBLIC_URL + "/reset"}
              className="text-xs text-gray-600 hover:underline"
            >
              {t("Forgot password?")}
            </Link>
            <Button onClick={onClick} text={buttonText} />
          </div>
          {errorMessage !== "" ? (
            <span className="mt-2 italic text-sm text-red-500 inline-block">
              {errorMessage}
            </span>
          ) : null}
        </form>
        <div className="mt-4 text-white text-xs">
          {t("Don’t have an account?")} {/* eslint-disable-next-line */}
          {/* <a
            href={`https://equalplay.eu/${dashboardLanguage()}`}
            className="underline"
          > */}
          <a href={`https://equalplay.eu/`} className="underline">
            {t("Get started!")}
          </a>
        </div>
      </div>
    </div>
  );
}
